import { Dispatch, SetStateAction } from 'react';
import configAPIJSON from '../../configAPI.json';
import { authorize, loginStatus } from '../../functions/API';
import { openCenteredPopupWindow } from '../../functions/utils/openCenteredPopupWindow';
import { UserSessionData } from '../../types/hooks';
const configAPI = JSON.parse(JSON.stringify(configAPIJSON));
const ENDPOINTS = configAPI.endpoints;

export const userLogin = async ({
  setUserSession,
}: {
  setUserSession: Dispatch<SetStateAction<UserSessionData>>;
}) => {
  const params = new URLSearchParams(window.location.search);
  const themeID = params.get('themeId');
  let isAuthorized: boolean | null = null;

  try {
    const { email, planName, paymentModel } = await loginStatus();

    if (themeID) {
      try {
        await authorize({ themeID });
        isAuthorized = true;
      } catch {
        isAuthorized = false;
      }
    }

    setUserSession({
      isLoggedIn: true,
      isAuthorized,
      email,
      planName,
      paymentModel,
    });
  } catch {
    _openLoginPopup({
      onSuccess: async ({ email, planName, paymentModel }) => {
        if (themeID) {
          try {
            await authorize({ themeID });
            isAuthorized = true;
          } catch {
            isAuthorized = false;
          }
        }

        setUserSession({
          isLoggedIn: true,
          isAuthorized,
          email,
          planName,
          paymentModel,
        });
      },
    });
  }
};

const _openLoginPopup = ({
  onSuccess,
  onFail,
}: {
  onSuccess?: ({
    email,
    planName,
    paymentModel,
  }: {
    email: string;
    planName: string | null;
    paymentModel: string | null;
  }) => void;
  onFail?: () => void;
}) => {
  const loginWindow = openCenteredPopupWindow({
    url: ENDPOINTS.loginPage,
    title: 'Patchkit Login',
    w: 400,
    h: 650,
  });

  const checkStatusInterval = setInterval(async () => {
    try {
      const { email, planName, paymentModel } = await loginStatus();
      loginWindow?.close();
      onSuccess && onSuccess({ email, planName, paymentModel });
    } catch {}

    if (!loginWindow || loginWindow?.closed) {
      clearInterval(checkStatusInterval);
      // Because checking login status produces a lot of 404 errors in console
      console.clear();
      onFail && onFail();
    }
  }, 1000);

  const autoCloseInterval = setInterval(async () => {
    clearInterval(autoCloseInterval);
    loginWindow?.close();
  }, 60000);
};
